import { render, staticRenderFns } from "./PropertyLightbox.vue?vue&type=template&id=561f81b8"
import script from "./PropertyLightbox.vue?vue&type=script&lang=js"
export * from "./PropertyLightbox.vue?vue&type=script&lang=js"
import style0 from "./PropertyLightbox.vue?vue&type=style&index=0&id=561f81b8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports